import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=22bcc172&scoped=true&lang=pug&"
import script from "./TopMenu.vue?vue&type=script&lang=js&"
export * from "./TopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bcc172",
  null
  
)

export default component.exports